import { TechnicalProduct } from '@cemex-core/cmx-api';
import { Action } from '@ngrx/store';
import { AddedValue } from '../models/added-values';

export enum AddedValueActionTypes {
  LOAD_ADDED_VALUES = '[Rms Added Value] Load added values',
  LOAD_ADDED_VALUES_NOT_FORMULATING = '[Rms Added Value] Load added values not formulating',
  LOAD_AVAILABLE_ADDED_VALUES_COMPLETED = '[Rms Added value] Load complete',
  CLEAN_NULL_ADDED_VALUES = '[Rms Added value] Clean added values',
  RESET = '[Rms Added Value] Reset',
}

export class LoadAddedValuesAction implements Action {
  readonly type = AddedValueActionTypes.LOAD_ADDED_VALUES;

  constructor(
    public payload: {
      productCode: string;
      index: number;
      addedValues?: AddedValue[];
    },
  ) {}
}

export class LoadAddedValuesCompleteAction implements Action {
  readonly type = AddedValueActionTypes.LOAD_AVAILABLE_ADDED_VALUES_COMPLETED;

  constructor(
    public payload: {
      productCode: string;
      addedValues: AddedValue[];
      index: number;
      technicalProduct: TechnicalProduct[];
    },
  ) {}
}

export class AddedValuesCleanAction implements Action {
  readonly type = AddedValueActionTypes.CLEAN_NULL_ADDED_VALUES;

  constructor() {}
}

export class AddedValuesResetAction implements Action {
  readonly type = AddedValueActionTypes.RESET;

  constructor() {}
}

export class LoadAddedValuesNotFormulatingAction implements Action {
  readonly type = AddedValueActionTypes.LOAD_ADDED_VALUES_NOT_FORMULATING;

  constructor(
    public payload: {
      productCode: string;
      index: number;
      addedValues?: AddedValue[];
      contractCode?: string;
    },
  ) {}
}

export type AddedValuesActions =
  | LoadAddedValuesAction
  | LoadAddedValuesCompleteAction
  | AddedValuesResetAction
  | AddedValuesCleanAction
  | LoadAddedValuesNotFormulatingAction;
